export default __webpack_public_path__ + "static/media/crianca-aprendendo.544acd9d.png";